import React from "react";
import BtaTrafficReport from "./Report";
import View from "common/View";
import help from "help/viewBtaStatsTraffic.md";

const BtaTraffic = ({returnView = null}) => (
  <View
    title="Optimization/Shaping Throughput"
    bodyPanelLayout="row"
    backButton={returnView}
    mdHelp={help}
  >
   <BtaTrafficReport returnView={returnView} />
 </View>
);

export default BtaTraffic;
